import {Component} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'app-hourglass',
    templateUrl: './hourglass.component.html',
    styleUrls: ['./hourglass.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({opacity: 0}),
                animate('.5s')
            ]),
            transition(':leave', [
                style({opacity: 1}),
                animate('.5s')
            ])
        ])
    ]
})
export class HourglassComponent {
}
